import { IConfigUnsafe } from '@cian/config/shared';
import { ILabelProps } from '@cian/ui-kit';
import * as colors from 'shared/constants/labelColors';
import { IOfferForMobileSiteSchema } from 'shared/repositories/search-engine/entities/offer/OfferForMobileSiteSchema';
import { IPhotoLabel, TPhotoLabelColor } from 'shared/types/photoLabel';

export const AUCTION_LABELS: IPhotoLabel[] = [{ name: 'Залоговая недвижимость, аукцион', color: 'white' }];

export const prepareLabels = (
  { photoLabels, author }: IOfferForMobileSiteSchema,
  config: IConfigUnsafe,
): ILabelProps[] => {
  const preparedPhotoLabels =
    !author?.bank || author?.agentLists ? photoLabels : [{ color: 'white', name: 'Залоговая недвижимость' }];

  const isElectronicTradingEnabled = config.getStrict<boolean>('AudienceMobile.ElectronicTrading.Enabled');

  const auctionBanks = config.get<number[]>('auction_banks') || [];

  const isAuctionCard = Boolean(author?.cianId && auctionBanks.includes(author.cianId));
  const isNewAuctionLabels = Boolean(author?.agentLists && author.agentLists.length > 0);

  /**
   * Для случаев, когда эл. торги включены, лейбл "Залоговая недвижимость, аукцион" необходимо убрать.
   * требования по старым условиям для лейблов в задаче CD-143469
   */
  const labels =
    isAuctionCard && !isNewAuctionLabels && !isElectronicTradingEnabled
      ? AUCTION_LABELS
      : [...(preparedPhotoLabels || [])];

  return labels.slice(0, 2).map(({ color, name }) => {
    return {
      color: colors.COLOR_MAP[color as TPhotoLabelColor] || 'theme-dark',
      background: colors.BACKGROUND_MAP[color as TPhotoLabelColor],
      icon: colors.ICON_MAP[color as TPhotoLabelColor],
      children: name,
    };
  });
};
